import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "control__text" }
const _hoisted_2 = {
  key: 0,
  class: "text__value"
}
const _hoisted_3 = {
  key: 1,
  class: "text__placeholder"
}
const _hoisted_4 = /*#__PURE__*/_createElementVNode("svg", {
  width: "20",
  height: "20",
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    d: "M15.8337 7.5L10.0003 13.3333L4.16699 7.5",
    stroke: "#94A3B8",
    "stroke-width": "2",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  })
], -1)
const _hoisted_5 = {
  key: 0,
  class: "dw-select__options"
}
const _hoisted_6 = {
  key: 0,
  class: "options__state"
}
const _hoisted_7 = {
  key: 1,
  class: "state__text text-red-500"
}
const _hoisted_8 = {
  key: 2,
  class: "state__text"
}
const _hoisted_9 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_loader = _resolveComponent("loader")!

  return (_openBlock(), _createElementBlock("div", {
    ref: "elementref",
    class: _normalizeClass(["dw-select", {
            'dw-select--disabled': _ctx.disabled,
            'dw-select--bordered': _ctx.bordered,
        }])
  }, [
    _createElementVNode("div", {
      class: "dw-select__control",
      onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.toggleOptions && _ctx.toggleOptions(...args)))
    }, [
      _createElementVNode("div", _hoisted_1, [
        (_ctx.isValueShown)
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, _toDisplayString(_ctx.valueLabel), 1))
          : _createCommentVNode("", true),
        (_ctx.isPlaceholderShown)
          ? (_openBlock(), _createElementBlock("div", _hoisted_3, _toDisplayString(_ctx.placeholder), 1))
          : _createCommentVNode("", true)
      ]),
      _hoisted_4
    ]),
    (_ctx.is_opened)
      ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
          (_ctx.loading || _ctx.failed || _ctx.options.length === 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                (_ctx.loading)
                  ? (_openBlock(), _createBlock(_component_loader, {
                      key: 0,
                      class: "primary"
                    }))
                  : (_ctx.failed)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_7, "Произошла ошибка"))
                    : (_ctx.options.length === 0)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_8, "Нет данных"))
                      : _createCommentVNode("", true)
              ]))
            : _createCommentVNode("", true),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.options, (option) => {
            return (_openBlock(), _createElementBlock("div", {
              class: _normalizeClass(["options__option", { 'option--selected': _ctx.isOptionSelected(option) }]),
              key: option.id,
              onClick: ($event: any) => (_ctx.selectOption(option))
            }, _toDisplayString(option[_ctx.optionLabelKey]), 11, _hoisted_9))
          }), 128))
        ]))
      : _createCommentVNode("", true)
  ], 2))
}